import React, { createContext, useContext, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, Outlet } from 'react-router-dom';
import './App.css';
import { Toaster, toast } from 'sonner';
import { PeriodProvider } from './lib/period';
import { ThemeProvider } from './lib/theme';
import { AppShell } from './components/AppShell';

import Dashboard from './pages/Dashboard';
import DatabaseStok from './pages/DatabaseStok'; // <-- Impor halaman Database Stok baru
import PemantauanStok from './pages/PemantauanStok';
import MasterReagen from './pages/MasterReagen';
import DataLIS from './pages/DataLIS';
import PRF from './pages/PRF';
import Penerimaan from './pages/Penerimaan';
import AnalisisExcel from './pages/AnalisisExcel';
import Pengaturan from './pages/Pengaturan';
import Analitik from './pages/Analitik';
import RiwayatAktivitas from './pages/RiwayatAktivitas';
import Login from './pages/Login';

export const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('labstock_user');
    return saved ? JSON.parse(saved) : null;
  });

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('labstock_user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('labstock_user');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

const ProtectedLayout = () => {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return (
    <PeriodProvider>
      <AppShell>
        <Outlet />
      </AppShell>
    </PeriodProvider>
  );
};

// Komponen Pembatas Akses dengan Popup Toast
const RoleRoute = ({ allowedRoles, children }) => {
  const { user } = useAuth();
  
  if (!allowedRoles.includes(user?.role)) {
    toast.error('Akses Ditolak: Anda tidak memiliki hak akses ke halaman ini.');
    return <Navigate to="/" replace />;
  }
  return children;
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            
            <Route element={<ProtectedLayout />}>
              {/* Akses untuk Semua Role */}
              <Route path="/" element={<Dashboard />} />
              <Route path="/database-stok" element={<DatabaseStok />} /> {/* <-- Route Database Stok baru */}
              <Route path="/analitik" element={<Analitik />} />
              <Route path="/pemantauan" element={<PemantauanStok />} />
              <Route path="/prf" element={<PRF />} />
              <Route path="/penerimaan" element={<Penerimaan />} />
              <Route path="/riwayat" element={<RiwayatAktivitas />} />
              
              {/* Akses Admin & Koordinator */}
              <Route path="/data-lis" element={<RoleRoute allowedRoles={['Admin', 'Koordinator']}><DataLIS /></RoleRoute>} />
              <Route path="/master-reagen" element={<RoleRoute allowedRoles={['Admin', 'Koordinator']}><MasterReagen /></RoleRoute>} />
              <Route path="/analisis-excel" element={<RoleRoute allowedRoles={['Admin', 'Koordinator']}><AnalisisExcel /></RoleRoute>} />
              
              {/* Akses Eksklusif Admin */}
              <Route path="/pengaturan" element={<RoleRoute allowedRoles={['Admin']}><Pengaturan /></RoleRoute>} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
